module.exports = __webpack_public_path__ + "static/media/ic_config_stats.aaf9af85.png";